module.exports = __webpack_public_path__ + "static/media/soviet_strongpoint2_120.6f9c9601.png";